let box = [
    {
      path: '/box/detail',
      name: 'detail',
      component: () => import('@/views/box/detail'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/box/open',
      name: 'open',
      component: () => import('@/views/box/open'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/mall/detail',
      name: 'malldetail',
      component: () => import('@/views/mall/detail'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/mall/list',
      name: 'malllist',
      component: () => import('@/views/mall/list'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/mall/orderForm',
      name: 'orderForm',
      component: () => import('@/views/mall/orderForm'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/mall/order',
      name: 'order',
      component: () => import('@/views/mall/order'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/mall/orderInfo',
      name: 'orderInfo',
      component: () => import('@/views/mall/orderInfo'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/box/exchange',
      name: 'exchange',
      component: () => import('@/views/box/exchange'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/box/exResult',
      name: 'exResult',
      component: () => import('@/views/box/exResult'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/box/pickup',
      name: 'pickup',
      component: () => import('@/views/box/pickup'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/box/pickingForm',
      name: 'pickingForm',
      component: () => import('@/views/box/pickingForm'),
      meta: {
        anonymous: false,
        keepAlive: true
      }
    },
    {
      path: '/setting',
      name: 'setting',
      component: () => import('@/views/setting/index'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/user/index'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/user/nickname',
      name: 'nickname',
      component: () => import('@/views/user/nickname'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/user/address',
      name: 'address',
      component: () => import('@/views/user/address'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/user/addressSetting',
      name: 'addressSetting',
      component: () => import('@/views/user/addressSetting'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/user/account',
      name: 'account',
      component: () => import('@/views/user/account'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/user/incomedetail',
      name: 'incomedetail',
      component: () => import('@/views/user/incomedetail'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    }
    ,
    {
      path: '/user/recharge',
      name: 'recharge',
      component: () => import('@/views/user/recharge'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/user/coupon',
      name: 'coupon',
      component: () => import('@/views/user/coupon'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    }
    
]
export default box


// WEBPACK FOOTER //
// ./src/router/box.js